import { Component, computed, inject, signal } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoReadonlyFields } from '@demo/data/demo-cipo-fields';
import { FieldTypeEnum } from '@models/module/fields/enums';
import { ActivityDetailsItem, ActivityFieldType, TableFieldValueType } from '@models/module/fields/main';
import { TableFieldViewComponent } from '@module-definition/table-field/table-field-view/table-field-view.component';
import { ModuleInstanceService } from '@module-instance/services';
import { CipoTextViewComponent } from '@shared/components/fields/cipo-text-view/cipo-text-view.component';

@Component({
  selector: 'cipo-demo-readonly-fields',
  imports: [CipoTextViewComponent, TableFieldViewComponent, MatTableModule, FlexLayoutModule],
  templateUrl: './demo-readonly-fields.component.html',
})
export class DemoReadonlyFieldsComponent {
  private readonly moduleInstanceService = inject(ModuleInstanceService);
  fields = DemoReadonlyFields;

  activityItemDetails = signal<ActivityDetailsItem>(null);
  tableField = computed(() => {
    const fields = this.activityItemDetails()?.fields;
    return fields?.find(field => field.type === FieldTypeEnum.Table) as unknown as ActivityFieldType<
      TableFieldValueType[]
    >;
  });

  ngOnInit(): void {
    // I use these values to be sure it gets's the correct values
    this.moduleInstanceService.getActivityItemDetails({ contractId: 52, actionInstanceId: 250611 }).subscribe(r => {
      this.activityItemDetails.set(r);
    });
  }
}
